import { ActionTree } from "vuex";
import { State } from "./state";
import { findAll } from "@/store/Crud/functions/actions";
import { cancelInvoice } from "@/store/PaymentWorkflow/actions";

export default <ActionTree<State, any>>{
  findAll,
  cancelInvoice,
};
